import React from "react";
import { Container, NavbarLink } from "./style";
import { navItems } from "../../utils/navbar";

export default function Navbar() {
  return (
    <Container>
      {navItems.map(({ path, title, child }, index) => {
        return (
          <NavbarLink activeStyle={{ color: "#6A983C" }} to={path}>
            {title}
          </NavbarLink>
        );
      })}
    </Container>
  );
}
